import { UserInfo } from '@intigral/domain';
import { getUserInfo } from './user';
import { IChannels } from '../features/epg/types/iEpgGudeContainer';

const PREMIUM_TIER_GUIDs = ['PLUS_TIER']; // More premium tiers can be added here if needed in the future.

class UserAccessControl {
    private _userInfo: UserInfo | null = null;
    public get userInfo(): UserInfo {
        if (!this._userInfo) this._userInfo = getUserInfo();
        return this._userInfo;
    }

    public get isPremiumUser(): boolean {
        return PREMIUM_TIER_GUIDs.includes(this.userInfo?.tierConfig?.tierGuid);
    }

    public canAccessChannel(channel: Partial<IChannels>): boolean {
        if (this.isPremiumUser) {
            const userSubscriptionGUIDs = this.userInfo?.subscriptionGUID;
            return (
                channel?.subscriptions?.some((channelSubscription) =>
                    userSubscriptionGUIDs?.includes(channelSubscription.subscriptionGUID)
                ) ?? true
            );
        }
        return true;
    }
}

export const userAccessControl = new UserAccessControl();
